// @flow
import styled from 'styled-components';
import { SelectTheme } from '../../select';
import { InputTheme } from '../../input';
import { FormElementTheme } from '../../form-element';
import { flamingo, silverGrey } from '../../colors';
import { media } from '../..';
/*::
import type { PhoneInputThemeType } from '../';
*/

var DefaultTheme
/*: PhoneInputThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-1vpsswq-0"
  })(["position:relative;display:flex;width:100%;box-sizing:border-box;&:after{z-index:2;position:absolute;bottom:20px;left:0;content:'';display:block;width:100%;height:1px;background-color:", ";}"], function (pr) {
    return pr.focused ? flamingo() : silverGrey();
  }),
  SelectContainer: styled.span.withConfig({
    displayName: "theme__SelectContainer",
    componentId: "sc-1vpsswq-1"
  })(["flex-shrink:0;flex-grow:0;flex-basis:12rem;min-width:5rem;", "{flex-basis:10rem;}", "{flex-basis:12rem;}"], media.max(1336), media.max(1100)),
  Select: SelectTheme,
  SelectFormElement: FormElementTheme,
  InputFormElement: Object.assign({}, FormElementTheme, {
    Main: styled(FormElementTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "sc-1vpsswq-2"
    })(["flex-grow:3;overflow:hidden;"]),
    Label: styled(FormElementTheme.Label).withConfig({
      displayName: "theme__Label",
      componentId: "sc-1vpsswq-3"
    })(["white-space:nowrap;"])
  }),
  InputComponent: InputTheme
};
export default DefaultTheme;